const HTML_MARKER = '=== Original Email Body (HTML) ==='
const TEXT_MARKER = '=== Original Email Body (Plain Text) ==='

export function reportedMessage(content = '') {
  const htmlAt = content.indexOf(HTML_MARKER)
  const textAt = content.indexOf(TEXT_MARKER)
  return {
    html: htmlAt < 0 ? '' : content.slice(htmlAt + HTML_MARKER.length).trim(),
    text: textAt < 0 ? '' : content.slice(textAt + TEXT_MARKER.length, htmlAt < 0 ? undefined : htmlAt).trim(),
  }
}

export function originalEmailAttachment(attachments = []) {
  return attachments.find(file => /\.(eml|msg)$/i.test(file.name) && /^\/root\/SecurityReportsAttachments\/[^?#]+$/i.test(file.url))
}

// Rebuild from an inert template using a formatting-only allowlist. No original
// attributes, styles, links, images, forms, SVG or active content reach the frame.
export function safeEmailDocument(html, doc = document) {
  const source = doc.createElement('template')
  source.innerHTML = html
  const allowed = new Set('P DIV SPAN BR HR B STRONG I EM U S SMALL BLOCKQUOTE PRE CODE H1 H2 H3 H4 H5 H6 UL OL LI TABLE THEAD TBODY TFOOT TR TD TH'.split(' '))
  const discard = new Set('SCRIPT STYLE TEMPLATE NOSCRIPT IFRAME FRAME OBJECT EMBED SVG MATH HEAD META LINK BASE FORM INPUT BUTTON TEXTAREA SELECT OPTION IMG AUDIO VIDEO SOURCE'.split(' '))
  function copy(node, depth = 0) {
    if (node.nodeType === 3) return doc.createTextNode(node.textContent)
    if (node.nodeType !== 1 || discard.has(node.tagName) || depth > 64) return doc.createTextNode('')
    const clean = doc.createElement(allowed.has(node.tagName) ? node.tagName.toLowerCase() : 'span')
    for (const child of node.childNodes) clean.append(copy(child, depth + 1))
    return clean
  }
  const clean = doc.createElement('div')
  for (const node of source.content.childNodes) clean.append(copy(node))
  return '<!doctype html><html><head><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="default-src \'none\'; style-src \'unsafe-inline\'; form-action \'none\'; base-uri \'none\'"><style>body{font:16px/1.6 system-ui;margin:20px;overflow-wrap:anywhere;color:#172b4d;background:white}table{border-collapse:collapse}td,th{border:1px solid #ddd;padding:6px}pre{white-space:pre-wrap}</style></head><body dir="auto">' + clean.innerHTML + '</body></html>'
}
